/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { FormControlLabel, Checkbox } from "@mui/material";
import ArgosFlexbox from "../../../../../../components/Containers/ArgosFlexbox";
import ArgosMenuItem from "../../../../../../components/Form/Select/ArgosMenuItem";
import ArgosSelect from "../../../../../../components/Form/Select/ArgosSelect";
import { useAppSelector } from "../../../../../../../redux/hooks";
import { selectGlobalDialogState } from "../../../../../../../redux/ducks/GlobalDialog/slice";
import { MRT_Cell, MRT_ColumnDef, MaterialReactTable } from "material-react-table";
import { useEffect, useState } from "react";
import { CamerarPropertiesObject, CamerarPropertiesTableRow, cameraPropsKeyToTitleMap, cameraLensPropsKeyToTitleMap } from "../../constants";
import { useHasWriteAccess } from "../../../../../../../redux/ducks/AccessControl/accessControlHelpers";
import { toast } from "react-hot-toast";

import {ArgosTableSimple} from "../../../../../../components/Table/ArgosTableSimple";

interface LensProps{
    baselineData: any
    sensorCameraData: any
    jsonData: any
}

const LensProperties = (props: LensProps) => {

  const isDialogOpen = useAppSelector(selectGlobalDialogState).isOpen
  const [tableData, setTableData] = useState<CamerarPropertiesTableRow[]>([]);
  const hasWriteAccess = useHasWriteAccess();
  const [validationErrors, setValidationErrors] = useState<any>({});

  useEffect(() => {
    mapPropsToRowFormat()
  }, [props])

  const mapPropsToRowFormat = () => {
    let _tableData: CamerarPropertiesTableRow[] = []
    const baselineData = props?.jsonData;
    cameraLensPropsKeyToTitleMap.forEach((element: CamerarPropertiesObject) => {
      let propertyValue = baselineData[element.key]
      let camerapropertyObjectAsRow: CamerarPropertiesTableRow = {
        propertyName: element.label,
        propertyValue,
        unit: element.unit
      }
      _tableData.push(camerapropertyObjectAsRow)
    })
    setTableData(_tableData)
    
  }
  function helperSetValidationErrors(newVal: string, cell: any, message: string) {
    setValidationErrors({
        ...validationErrors,
        [cell.id]: message
    })

    toast.error(message,
        {
            style: {
                marginTop: "300px"
            },
            duration: 3000
        })
  }

  const validateInput = (newVal: string, cell: any) => {
    let newValnum = Number(newVal)
    if (isNaN(newValnum)) {
        helperSetValidationErrors(newVal, cell, `Not valid value, must be a number`)
        return false
    }
    return true
  }
  const getCommonEditTextFieldProps =
  (
      cell: MRT_Cell<CamerarPropertiesTableRow>,
  ): MRT_ColumnDef<CamerarPropertiesTableRow>['muiEditTextFieldProps'] => {
      return {
          error: !!validationErrors[cell.id],
          helperText: validationErrors[cell.id],
          onKeyDown: (e) => {
              if (e.code == "Tab") {
                  e.stopPropagation()
                  e.preventDefault()
              }
          },
      };
  }
  const cameraPropertiesTableColumns: MRT_ColumnDef<CamerarPropertiesTableRow>[] = [
    {
      header: "Name",
      accessorKey: "propertyName",
      enableEditing: false,
    },
    {
      header: "Value",
      accessorKey: "propertyValue",
      enableEditing: true,
      minSize: 300,
      muiEditTextFieldProps: ({ cell }) => ({
        ...getCommonEditTextFieldProps(cell),
        disabled: !hasWriteAccess 
      }),
    },
    {
        header: "Unit",
        accessorKey: "unit",
        enableEditing: false,
        // minSize: 80,
    }
  ]

  
  return (
  <ArgosFlexbox vertical style={{width: "100%"}}>
    <div style={{padding: "5px", width: "100%"}}>
      <ArgosTableSimple 
        columns={cameraPropertiesTableColumns}
        data={tableData}

        initialState={{density: 'compact'}}
        editDisplayMode="cell"
        enableEditing
        enableBottomToolbar={false}
        enablePagination={false}
      />
    </div>   
   </ArgosFlexbox>)
}

export default LensProperties;